export const EShapeActionValueOnInputAction = wcardinal.ui.EShapeActionValueOnInputAction;